import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckIcon, GiftIcon, ZapIcon } from 'lucide-react';
const productImage = 'https://cdn.magicpatterns.com/uploads/mTGdQzionjNrhUtByQMppW/ChatGPT_Image_10_jul_2026,_09_43_49.png';
export function Hero() {
  const points = [['6 Tomos Documentales', BookOpenIcon], ['3 Bonos Exclusivos', GiftIcon], ['+300 páginas', CheckIcon], ['Acceso inmediato', ZapIcon]];
  const scrollToOffer = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const offerCard = document.getElementById('checkout-card');
    if (offerCard) {
      const top = offerCard.getBoundingClientRect().top + window.scrollY - 24;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
      window.history.replaceState(null, '', '#oferta-premium');
    }
  };
  return <section className="relative overflow-hidden px-5 py-8 text-center md:py-12" data-id="element-113">
      <div className="pointer-events-none absolute left-1/2 top-0 h-80 w-80 -translate-x-1/2 rounded-full bg-gold/10 blur-[110px]" data-id="element-114" />
      <div className="relative mx-auto max-w-3xl" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.65
      }} data-id="element-116">
          <p className="mb-3 text-[10px] font-bold uppercase tracking-[.22em] text-gold sm:text-xs" data-id="element-117">
            Archivo documental · Mesoamérica
          </p>
          <h1 className="maya-title mx-auto max-w-2xl text-2xl font-semibold leading-tight text-stone-light sm:text-3xl md:text-4xl" data-id="element-118">
            Los Secretos de la{' '}
            <span className="text-gold-light" data-id="element-119">Civilización Maya</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.75,
        delay: 0.15
      }} className="relative mx-auto mt-4 w-full max-w-[300px] sm:max-w-sm" data-id="element-120">
          <div className="absolute inset-8 rounded-full bg-gold/15 blur-[65px]" data-id="element-121" />
          <img src={productImage} alt="Colección digital Los Secretos de la Civilización Maya" className="relative w-full rounded-xl border border-gold/25 shadow-2xl" data-id="element-122" />
        </motion.div>

        <div className="mt-4" data-id="element-123">
          <p className="mx-auto max-w-md text-sm leading-6 text-stone sm:text-base" data-id="element-124">
            Historia, misterios y legado de una civilización extraordinaria.
          </p>
          <ul className="mx-auto mt-4 flex max-w-md flex-wrap justify-center gap-2" data-id="element-125">
            {points.map(([label, Icon]) => <li key={label as string} className="flex items-center gap-1.5 rounded-full border border-gold/25 bg-gold/5 px-2.5 py-1.5 text-[11px] text-stone-light sm:text-xs" data-id="element-126">
                <Icon className="h-3 w-3 text-gold-light" data-id="element-127" />
                {label}
              </li>)}
          </ul>
          <a href="#oferta-premium" onClick={scrollToOffer} className="mt-5 inline-flex w-full items-center justify-center rounded-lg bg-gold px-7 py-3.5 text-sm font-bold tracking-wide text-dark shadow-[0_0_28px_rgba(199,154,69,.26)] transition hover:bg-gold-light sm:w-auto" data-id="element-128">
            QUIERO ACCEDER AHORA
          </a>
          <p className="mt-3 text-[11px] text-stone" data-id="element-129">
            Acceso digital inmediato · Garantía de 7 días
          </p>
        </div>
      </div>
    </section>;
}